import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';
// import buildExportQuery from './queryies/_export_all';
import { saveAs } from 'file-saver';
import moment from 'moment';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
};

export const ITEMS_LIST = 'GET_CLIENT_LIST';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                id: 'delivery_zone_groups.id',
                name: 'delivery_zone_groups.name',
                created_at: 'delivery_zone_groups.created_at',
                updated_at: 'delivery_zone_groups.updated_at',
                zones: 'grouped_delivery_zones.zones'
              };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["delivery_zone_groups.name", {"$": `%${query.name}%`}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    from: 's:delivery_zone_groups',
                    from_as: 'delivery_zone_groups',
                    joins: [
                        {
                            join: {
                              columns: {
                                delivery_zone_group_id: 'delivery_zones.delivery_zone_group_id',
                                zones: {
                                    $array_agg: {
                                      $obj: {
                                        // product_name: 'delivery_zones.product_name',
                                        id: 'delivery_zones.id',
                                        name: 'delivery_zones.name',
                                        created_at: 'delivery_zones.created_at',
                                        updated_at: 'delivery_zones.updated_at',
                                      }
                                    }
                                  },
                              },
                              from: 's:delivery_zones',
                              from_as: 'delivery_zones',
                              groups: [
                                'delivery_zones.delivery_zone_group_id'
                              ],
                            //   where: {
                            //     $or: [
                            //       { $eq: ['dpc.is_sample', { $: true } ] },
                            //       { $eq: ['pc.is_sample', { $: true } ] },
                            //     ]
                            //   }
                            },
                            type: 'left',
                            as: 'grouped_delivery_zones',
                            on: { $eq: ['grouped_delivery_zones.delivery_zone_group_id', 'delivery_zone_groups.id'] }
                        }
                    ],
                    // groups: [
                    //     'cl.id', 'cl.name', 'cl.category_income', 'cl.category_profit',
                    //     'empl.id', 'empl.name',
                    //     'city.id', 'city.name',
                    //     'ptype.id', 'ptype.name'
                    // ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'desc' ? { $desc: [columns[query.sortField || 'name' ]] } : { $asc: [columns[query.sortField || 'name']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    productToArchive({ rootState }, productId) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('PRODUCT_TO_ARCHIVE')
                    .update(productId, {
                        archived_at: moment().format('YYYY-MM-DDTHH:mm:ss')
                    })
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('PRODUCT_TO_ARCHIVE');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    productToUnarchive({ rootState }, productId) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('PRODUCT_TO_ARCHIVE')
                    .update(productId, {
                        archived_at: null
                    })
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('PRODUCT_TO_ARCHIVE');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    setProductContainerCost({ rootState }, data) {
        const vm = (this as any)._vm;

        const query = data.id ?
            vm.$q('SAVE_PRIME_COST').update(data.id, data) :
            vm.$q('SAVE_PRIME_COST').create('prime_costs', data);

        return new Promise((resolve, reject) => {
            vm.$db([
                query
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SAVE_PRIME_COST');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },
};

export const mutations: MutationTree<WorkPlanBoardState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_delivery_zones_manager';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
